import { getPageMeta, type PageMetaEntry, type PageMetaKey } from '../config/pageMeta';
import { ROUTE_KEYWORDS } from '../config/searchIndex';
import type { SeoPageOverride, SiteSeoConfig } from '../config/siteConfig';
import type { SiteLanguage } from './constants';

export const DEFAULT_GLOBAL_KEYWORDS =
  'SAP Business One, Logo Yazılım, ERP çözümleri, dijital dönüşüm, yazılım danışmanlığı, İstanbul, Boyum-IT, Computec';

function parseKeywordList(value?: string): string[] {
  if (!value?.trim()) return [];
  return value
    .split(',')
    .map((k) => k.trim())
    .filter(Boolean);
}

function mergePageOverride(
  base: PageMetaEntry,
  override?: SeoPageOverride,
): PageMetaEntry & { keywords: string } {
  if (!override) {
    return { ...base, keywords: '' };
  }
  return {
    ...base,
    title: override.title?.trim() || base.title,
    description: override.description?.trim() || base.description,
    keywords: override.keywords?.trim() ?? '',
  };
}

export function resolvePageMeta(
  lang: SiteLanguage,
  pageKey: PageMetaKey,
  seoConfig?: SiteSeoConfig,
): PageMetaEntry & { keywords: string } {
  const base = getPageMeta(lang, pageKey);
  const override = seoConfig?.pages?.[pageKey]?.[lang];
  return mergePageOverride(base, override);
}

export function resolveGlobalKeywords(seoConfig?: SiteSeoConfig): string {
  const custom = seoConfig?.globalKeywords?.trim();
  return custom || DEFAULT_GLOBAL_KEYWORDS;
}

export function resolvePageKeywords(
  lang: SiteLanguage,
  pageKey: PageMetaKey,
  seoConfig?: SiteSeoConfig,
): string {
  const pageOverride = seoConfig?.pages?.[pageKey]?.[lang]?.keywords?.trim();
  if (pageOverride) return pageOverride;
  return resolveGlobalKeywords(seoConfig);
}

export function resolveSearchKeywords(
  pageKey: PageMetaKey,
  seoConfig?: SiteSeoConfig,
): string[] {
  const base = ROUTE_KEYWORDS[pageKey] ?? [];
  const trKw = parseKeywordList(seoConfig?.pages?.[pageKey]?.tr?.keywords);
  const enKw = parseKeywordList(seoConfig?.pages?.[pageKey]?.en?.keywords);
  return [...new Set([...base, ...trKw, ...enKw])];
}
